exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".order-one{-ms-flex-order:1!important;order:1!important}", "", {"version":3,"sources":["/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/rsvp/vendor-rsvp-page/vendor-rsvp-page.component.css"],"names":[],"mappings":"AAAA,WACE,2BAAA,iBAAoB,CACrB","file":"vendor-rsvp-page.component.css","sourcesContent":[".order-one {\n  order: 1 !important;\n}\n"],"sourceRoot":""}]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/rsvp/vendor-rsvp-page/vendor-rsvp-page.component.css
// module id = 8aQ7
// module chunks = 0